export const employeeEn = {
  expense: `Expense`,
  employee: `Employee`,
  employee_management: `Employee Management`,
  add_employee: `Add employee`,
  edit_employee: `Edit employee`,
  cancel: `Cancel`,
  save: `Save`,
  update: `Update`,
  employee_updated_success: `Employee updated successfully`,
  employee_created_success: `Employee created successfully`,
  delete_employee_dialog: `Delete employee`,
  deleted_multiple: `{count} employee(s) deleted successfully`,
  delete_failed: `Failed to delete {count} employee(s)`,

  // Form labels
  select_user: `Select user`,
  user_email: `User email`,
  user_cannot_be_changed: `User cannot be changed`,
  employee_code: `Code`,
  first_name: `First name`,
  last_name: `Last name`,
  department: `Department`,
  designation: `Designation`,
  gender: `Gender`,
  employment_type: `Type`,
  address: `Address`,
  date_of_birth: `Date of birth`,
  date_of_joining: `Date of joining`,
  added_by: `Added by`,

  // Gender options
  male: `Male`,
  female: `Female`,
  other: `Other`,

  // Employment type options
  full_time: `Full time`,
  contract: `Contract`,

  // Validation messages
  user_required: `User is required`,
  user_notfound: `User not found`,
  user_not_active: `User is not active`,
  employeecode_required: `Employee code is required`,
  firstname_required: `First name is required`,
  lastname_required: `Last name is required`,
  department_required: `Department is required`,
  designation_required: `Designation is required`,
  address_required: `Address is required`,
  employee_already_created: `Employee already exists for this user`,
  employeecode_already_exists: `Employee code already exists`,
  employee_not_found: `Employee not found`,
  employee_already_deactive: `Employee is already deactivated`,
  successfully_deleted: `Successfully deleted`,
  select_gender: "Select gender",
  select_employment_type: "Select employment type",

  // Other validation messages (for Yup schema)
  user_selection_required: `User selection is required`,
  invalid_employee_code: `Employee code can only contain letters and numbers`,
  firstname_min: `First name must be at least 2 characters`,
  firstname_max: `First name cannot exceed 50 characters`,
  lastname_min: `Last name must be at least 2 characters`,
  lastname_max: `Last name cannot exceed 50 characters`,
  department_min: `Department must be at least 2 characters`,
  designation_min: `Designation must be at least 2 characters`,
  invalid_gender: `Invalid gender selection`,
  invalid_employment_type: `Invalid employment type`,
  address_min: `Address must be at least 5 characters`,
  something_went_wrong: `Something went wrong`,
  error_fetching_employee_data: `Error fetching employee data`,
};
